import { Group, type GroupProps } from "@mantine/core"
import type { ReactNode } from "react"

export function FormActions({
  children,
  mt = "md",
  ...props
}: GroupProps & { children: ReactNode }) {
  return (
    <Group align="center" gap="xs" mt={mt} {...props}>
      {children}
    </Group>
  )
}
